"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
exports.Radio = function (props) {
    return react_1.default.createElement(StyledRadio, tslib_1.__assign({}, props, { disableRipple: true }));
};
exports.Radio.displayName = 'FOS_Radio';
var StyledRadio = styled_components_1.default(core_1.Radio)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    color: ", " !important;\n    padding: 0rem;\n\n    &:hover {\n      background-color: transparent !important;\n    }\n  }\n"], ["\n  && {\n    color: ", " !important;\n    padding: 0rem;\n\n    &:hover {\n      background-color: transparent !important;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[900];
});
var templateObject_1;
